import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getCompatibilityCarsGroup = createAsyncThunk('compatibility/getCompatibilityCarsGroup',
  async (cars, { rejectWithValue }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/compatibility/carData', { cars, group: true });
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return { data };
    } catch (error) {
      return rejectWithValue(error?.data.message);
    }
  });

export default getCompatibilityCarsGroup;
